import {
  IsBoolean,
  IsString,
  IsDefined,
  ValidateNested,
  IsIn,
  IsArray,
  IsOptional,
  IsObject,
} from 'class-validator';
import { Type } from 'class-transformer';
import { ValidateNodeProps } from './validators/ValidateNodeProps';
import {
  CONTENT_BLOCK_NAME,
  BUTTON_NODE_NAME,
  TEXT_NODE_NAME,
  PAGE_NODE_NAME,
  IMAGE_NODE_NAME,
  ICON_NODE_NAME,
  VIDEO_NODE_NAME,
  FORM_NODE_NAME,
  COUNTDOWN_NODE_NAME,
  POPUP_NODE_NAME,
  EMBED_NODE_NAME,
} from '@builder4/shared/utils/constants';
import { FORM_SUB_NODES } from '@builder4/shared/components/Form/formRegistry';

export const VALID_COMPONENT_NAMES = [
  CONTENT_BLOCK_NAME,
  BUTTON_NODE_NAME,
  TEXT_NODE_NAME,
  PAGE_NODE_NAME,
  IMAGE_NODE_NAME,
  ICON_NODE_NAME,
  VIDEO_NODE_NAME,
  FORM_NODE_NAME,
  COUNTDOWN_NODE_NAME,
  POPUP_NODE_NAME,
  EMBED_NODE_NAME,
  ...FORM_SUB_NODES,
];

export class NodeTypeDto {
  @IsDefined()
  @IsString()
  // Some of our component names have spaces in them, so we need to remove them
  // to replicate how CraftJS handles turning our names into internal node types.
  @IsIn(VALID_COMPONENT_NAMES.map((name) => name.replace(/\s+/g, '')))
  resolvedName!: string;
}

export class SerializedNodeDto {
  @IsDefined()
  @ValidateNested()
  @Type(() => NodeTypeDto)
  type!: NodeTypeDto;

  @IsDefined()
  @IsBoolean()
  isCanvas!: boolean;

  @IsDefined()
  @ValidateNodeProps()
  props!: Record<string, unknown>;

  @IsDefined()
  @IsString()
  @IsIn(VALID_COMPONENT_NAMES)
  displayName!: string;

  @IsDefined()
  @IsObject()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  custom!: Record<string, any>;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsArray()
  @IsString({ each: true })
  nodes!: string[];

  @IsDefined()
  @IsObject()
  linkedNodes!: Record<string, string>;

  @IsOptional()
  @IsString()
  parent!: string;
}
